import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-DoubleArrow",
  "use": "svg-icon-DoubleArrow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-DoubleArrow\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h12v12H0z\" /><path d=\"M6 1c.325 0 .669.143 1.003.478l3.753 3.752a.833.833 0 0 1-1.179 1.18L6 2.83 2.423 6.41a.833.833 0 1 1-1.179-1.18l3.758-3.757C5.335 1.14 5.675 1 6 1zm0 4c.325 0 .669.143 1.003.478l3.753 3.752a.833.833 0 1 1-1.179 1.179L6 6.83l-3.577 3.58a.833.833 0 1 1-1.179-1.18l3.758-3.757C5.335 5.14 5.675 5 6 5z\" fill=\"#000\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol